"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var FormContext_1 = require("./Context/FormContext");
var ValuationWidgetContext_1 = require("./Context/ValuationWidgetContext");
var Types_1 = require("./Types");
var LoadingSpinner_1 = __importDefault(require("../Shared/Components/LoadingSpinner"));
var PromiseHelpers_1 = require("../Shared/Utility/PromiseHelpers");
var UpgradeOfferButton = function () {
    var formContext = (0, hooks_1.useContext)(FormContext_1.FormContext);
    var widgetContext = (0, hooks_1.useContext)(ValuationWidgetContext_1.ValuationWidgetContext);
    var _a = (0, hooks_1.useState)(false), showLoader = _a[0], setShowLoader = _a[1];
    // Some browsers utilize back/forward caching, which will cache the page in the state right before navigation occurs.
    // This can cause the Valuation Widget to appear like it's still submitting
    // https://web.dev/bfcache/
    (0, hooks_1.useEffect)(function () {
        // Detect back/forward cache and reset form
        var cleanup = function (event) {
            if (event.persisted || performance.getEntriesByType("navigation")[0].entryType === 'back_forward') {
                formContext.resetFormWithNewValue();
                widgetContext.resetErrorStateWithNewValue();
                setShowLoader(false);
            }
        };
        window.addEventListener('pageshow', cleanup);
        return function () {
            window.removeEventListener('pageshow', cleanup);
        };
    }, []);
    var validateLicensePlate = function () {
        var _a;
        var _b = formContext.formValue.plate, plateNumber = _b.plateNumber, state = _b.state;
        // check basic validation
        if (!widgetContext.hasValidLicensePlate(plateNumber)) {
            return false;
        }
        // strip space + dash
        return (((_a = widgetContext.normalizeAlphaNumericInput(plateNumber)) === null || _a === void 0 ? void 0 : _a.length) <= 8 && state) ? true : false;
    };
    var validateForm = function () {
        var _a = formContext.formValue, valuationMethod = _a.valuationMethod, vin = _a.vin;
        switch (true) {
            case valuationMethod === Types_1.PublicValuationMethod.LicensePlate && !validateLicensePlate():
                widgetContext.resetErrorStateWithNewValue(function (x) {
                    x.plate = true;
                });
                return false;
            case valuationMethod === Types_1.PublicValuationMethod.Vin && !widgetContext.hasValidVin(vin.enteredVin):
                widgetContext.resetErrorStateWithNewValue(function (x) {
                    x.vin = true;
                });
                return false;
        }
        return true;
    };
    var handleButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var delayTimeInMs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (formContext.isSubmitting || !validateForm())
                        return [2 /*return*/];
                    setShowLoader(true);
                    delayTimeInMs = 1000;
                    // Start the form submission but wait a moment to return the result so the UI doesn't flash
                    return [4 /*yield*/, (0, PromiseHelpers_1.delayPromiseAsync)(formContext.submitForm(function () { return setShowLoader(false); }), delayTimeInMs)];
                case 1:
                    // Start the form submission but wait a moment to return the result so the UI doesn't flash
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, preact_1.h)("button", { type: "button", id: "upgrade-offer-button", className: "call-to-action button wbac-font upgrade-offer-button", "data-loading": showLoader, onClick: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleButtonClick()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); } },
        (0, preact_1.h)("div", { className: "button-grid" },
            showLoader && (0, preact_1.h)(LoadingSpinner_1.default, { className: "submit-loading", color: "#fff", size: 40 }),
            (0, preact_1.h)("span", { class: "submit-label" }, "Submit"))));
};
exports.default = UpgradeOfferButton;
